// extracted by mini-css-extract-plugin
var _1 = "ModalContext_portalContainer__fd7a3";
export { _1 as "portalContainer" }
